import { useEffect } from "react";

// Application name written by the HTML template (<title>%REACT_APP_HTML_TITLE%</title>), read before any page changes it.
const APP_TITLE = document.title;
const TITLE_SEPARATOR = " – ";

// Gives each page its own tab title, "<page title> – <application name>" (RGAA 8.6).
// null leaves the title to a child page, such as the ErrorPage a page renders instead of itself:
// child effects run first, so the parent would otherwise overwrite it.
export const useDocumentTitle = (pageTitle: string | null): void => {
    useEffect(() => {
        if (null === pageTitle) {
            return;
        }

        // Session and vote titles may span several lines, with line breaks or <br> (see convertLineBreak).
        const singleLineTitle = pageTitle
            .replace(/<br\s*\/?>/gi, " ")
            .replace(/\s+/g, " ")
            .trim();
        document.title = singleLineTitle
            ? `${singleLineTitle}${TITLE_SEPARATOR}${APP_TITLE}`
            : APP_TITLE;
    }, [pageTitle]);
};
